import { Type } from 'class-transformer';
import {
  IsNumber,
  IsNumberString,
  IsOptional,
  Matches
} from 'class-validator';
import { PaymentDto } from '../payment.dto';

export class GiftCardTopupGenerateRequestDto {
  cardNumber: string;

  @IsNumberString()
  @Matches(/^\d{3}$/)
  cvvCode: number;

  @IsNumber()
  previousBalance?: number;

  @Type(() => PaymentDto)
  @IsOptional()
  payment?: PaymentDto;

  @IsOptional()
  @IsNumber()
  merchantId?: number;

  @IsNumber()
  amount: number;

  constructor(
    cardNumber: string,
    cvvCode: number,
    payment?: PaymentDto,
    previousBalance?: number,
    merchantId?: number,
    amount?: number
  ) {
    this.cardNumber = cardNumber;
    this.cvvCode = cvvCode;
    this.payment = payment;
    this.previousBalance = previousBalance;
    this.merchantId = merchantId;
    this.amount = amount;
  }
}
